module.exports = __webpack_public_path__ + "static/media/redsapp1.c5301406.png";